import { CollectionName } from '../../constants';
import { AssetCategory } from '../../models/assets';
import { migrateCollections } from '../helpers';
import {
  CurrentMigrationCollectionItem,
  MigratedMigrationCollectionItem,
  MigrationType,
  SingleCollectionMigrationOption,
} from '../types';

const migrateCryptoWalletAssets = (
  data: CurrentMigrationCollectionItem,
): MigratedMigrationCollectionItem => {
  const newData = { ...data };

  if (
    newData.category === AssetCategory.CENTRALIZED_WALLET ||
    newData.category === AssetCategory.DECENTRALIZED_WALLET
  ) {
    if (typeof newData.assetsInWallet === 'string') {
      newData.assetsInWallet = [newData.assetsInWallet];
    } else if (!newData.assetsInWallet) {
      newData.assetsInWallet = [];
    }
  }

  return newData;
};

const MIGRATION_OPTIONS: SingleCollectionMigrationOption[] = [
  { collectionName: CollectionName.ASSETS, migrateItemFunction: migrateCryptoWalletAssets },
];

const migrate: MigrationType['migrate'] = (data) => {
  return migrateCollections({
    data,
    migrationOptions: MIGRATION_OPTIONS,
  });
};

export const migration13: MigrationType = {
  migrate,
  version: 14,
};
